import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency, formatNumber } from '../../../lib/utils';

export default class RecipientAccountCampaignsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            campaigns: props.campaigns ? props.campaigns.sort((c1, c2) => c1.campaignName > c2.campaignName) : [],
            sortBy: 'campaignName',
            sortAsc: true,
            showTable: false
        };
    };

    sortTable(sortBy) {
        const sortAsc = this.state.sortBy === sortBy ? !this.state.sortAsc : true;
        const campaigns = this.state.campaigns.sort((c1, c2) => sortAsc ? c1[sortBy] > c2[sortBy] : c1[sortBy] < c2[sortBy]);
        this.setState({
            sortBy,
            sortAsc,
            campaigns
        });
    }

    render() {
        return (
            <div className="campaigns-card-container">
                <div className="campaigns-card card">
                    <div className="campaigns-card-header flex-justify flex-center">
                        <label className="input-label">Campaigns</label>
                        {this.props.campaignListId &&
                            <Link
                                className="btn btn-primary"
                                to={`/campaigns/lists/${this.props.campaignListId}`}>
                                Campaign List
                            </Link>}
                        <button className="btn btn-flat-accent"
                            onClick={() => this.setState({ showTable: !this.state.showTable })}>
                            {this.state.showTable ? "Hide" : "Show"}
                        </button>
                    </div>
                    {this.state.showTable && <div className="table-container">
                        {(this.state.campaigns && this.state.campaigns.length > 0)
                            ? <table className="table">
                                <thead>
                                    <tr className="table-header table-row">
                                        <th className={`sort ${this.state.sortBy === 'campaignName' ? 'active' : ''}`}>Campaign
                                        <div className="sort-arrows relative" onClick={this.sortTable.bind(this, 'campaignName')}>
                                                <i className="icon ion-android-arrow-dropup"></i>
                                                <i className="icon ion-android-arrow-dropdown"></i>
                                            </div>
                                        </th>
                                        <th className={`sort ${this.state.sortBy === 'count' ? 'active' : ''}`}>Count
                                        <div className="sort-arrows relative" onClick={this.sortTable.bind(this, 'count')}>
                                                <i className="icon ion-android-arrow-dropup"></i>
                                                <i className="icon ion-android-arrow-dropdown"></i>
                                            </div>
                                        </th>
                                        <th className={`sort ${this.state.sortBy === 'defaultAmount' ? 'active' : ''}`}>Amount Per Person
                                        <div className="sort-arrows relative" onClick={this.sortTable.bind(this, 'defaultAmount')}>
                                                <i className="icon ion-android-arrow-dropup"></i>
                                                <i className="icon ion-android-arrow-dropdown"></i>
                                            </div>
                                        </th>
                                        <th className={`sort ${this.state.sortBy === 'total' ? 'active' : ''}`}>Total
                                        <div className="sort-arrows relative" onClick={this.sortTable.bind(this, 'total')}>
                                                <i className="icon ion-android-arrow-dropup"></i>
                                                <i className="icon ion-android-arrow-dropdown"></i>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.campaigns.map(campaign => <tr key={campaign.campaignId} className="table-row">
                                        <td data-label="Campaign">
                                            <p>{campaign.campaignName}</p>
                                        </td>
                                        <td data-label="Count">
                                            <p>{formatNumber(campaign.count)}</p>
                                        </td>
                                        <td data-label="Amount Per Person">
                                            <p>{formatCurrency(campaign.defaultAmount, campaign.isIsraeli)}</p>
                                        </td>
                                        <td data-label="Total">
                                            <p>{formatCurrency(campaign.total, campaign.isIsraeli)}</p>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                            : <span className="accent-text no-results">No Campaigns</span>}
                    </div>}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/RecipientAccountCampaignsTable.jsx